import { faUserCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, Col, Row, Space, Typography } from 'antd'
import { useContext } from 'react'
import LabeledSwitch from '../../common/LabeledSwitch'
import VSpace from '../../common/VSpace'
import UsersPageContext from '../UsersPageContext'
import { useUsersRolesQuery } from '../usersQueries'

const { Text } = Typography

const UserRolesSection = () => {
  const { state: { roles }, dispatch } = useContext(UsersPageContext)
  const usersRolesQuery = useUsersRolesQuery()
  const roleOptions = usersRolesQuery.data || []

  const handleToggle = (roleName: string, checked: boolean) => {
    const updatedRoles = checked
      ? [...roles, roleName]
      : roles.filter(role => role !== roleName)

    dispatch({ type: 'SET_FIELD', fieldName: 'roles', payload: updatedRoles })
  }

  return (
    <Card title={<Space><FontAwesomeIcon icon={faUserCircle} />User Roles</Space>} bordered={false}>
      <Row gutter={[16, 16]}>
        {roleOptions.map((option, index) => (
          <Col span={6} key={index}>
            <VSpace>
              <LabeledSwitch
                label={option.rolename}
                value={roles.includes(option.rolename)}
                checked={roles.includes(option.rolename)}
                onChange={checked => handleToggle(option.rolename, checked)}
              />
              <Text type="secondary">{option.description}</Text>
            </VSpace>
          </Col>
        ))}
      </Row>
    </Card>
  )
}

export default UserRolesSection
